import styled from 'styled-components'
import { FlexByRow } from 'irmlib/styles'

const searchTextContainerWidth = '300px'

export const SearchContainer = styled(FlexByRow)`
  justify-content: flex-end;
  width: 100%;
`

export const SearchTextContainer = styled.div`
  width: ${searchTextContainerWidth};
`
